// @ts-nocheck
import * as Types from '../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetQuitApplicationPagesSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetQuitApplicationPagesSettingsQuery = { __typename?: 'Query', quitApplication: { __typename?: 'QuitApplication', applicableStatus: Types.QuitApplicationApplicableStatus } };


export const GetQuitApplicationPagesSettingsDocument = gql`
    query getQuitApplicationPagesSettings {
  quitApplication {
    applicableStatus
  }
}
    `;

/**
 * __useGetQuitApplicationPagesSettingsQuery__
 *
 * To run a query within a React component, call `useGetQuitApplicationPagesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuitApplicationPagesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuitApplicationPagesSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuitApplicationPagesSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>(GetQuitApplicationPagesSettingsDocument, options);
      }
export function useGetQuitApplicationPagesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>(GetQuitApplicationPagesSettingsDocument, options);
        }
export function useGetQuitApplicationPagesSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>(GetQuitApplicationPagesSettingsDocument, options);
        }
export type GetQuitApplicationPagesSettingsQueryHookResult = ReturnType<typeof useGetQuitApplicationPagesSettingsQuery>;
export type GetQuitApplicationPagesSettingsLazyQueryHookResult = ReturnType<typeof useGetQuitApplicationPagesSettingsLazyQuery>;
export type GetQuitApplicationPagesSettingsSuspenseQueryHookResult = ReturnType<typeof useGetQuitApplicationPagesSettingsSuspenseQuery>;
export type GetQuitApplicationPagesSettingsQueryResult = Apollo.QueryResult<GetQuitApplicationPagesSettingsQuery, GetQuitApplicationPagesSettingsQueryVariables>;